export default __webpack_public_path__ + "static/media/4s.8525cdf9.svg";